
import { ErrorHandler, Injectable, inject } from '@angular/core';

import {
  SentryService,
} from './core/sentry.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private sentryService = inject(SentryService);


  handleError(error: any) {
    this.sentryService.handleError(error);

    throw error;
  }
}
